import axios from "axios";
import { APIClient } from "./api_helper";

// Дотоод чат — 1:1 мессеж.
//
// ⚠️ Хэн хэнтэй чатлаж болохыг СЕРВЭР шийднэ (api_v2/routes/chat.js → canChat).
// Энд харагдаж буй жагсаалт нь аль хэдийн шүүгдсэн байдаг тул client талд
// нэмэлт шүүлт хийх шаардлагагүй — бас найдаж ч болохгүй.
const api = new APIClient();

const B = "/chat";

// Чатлаж болох хүмүүс: онлайн төлөв, сүүлийн мессеж, уншаагүй тоотой
export const getChatContacts = () => api.get(B + "/contacts");

// Header дээрх тэмдэгт зориулсан хөнгөн хүсэлт
export const getChatUnread = () => api.get(B + "/unread");

// Нэг ярианы түүх. `before` нь дээш гүйлгэхэд хуучныг нэмж ачаална.
export const getChatMessages = (userId, params) =>
  api.get(B + "/messages/" + userId, params);

export const sendChatMessage = (to, text) => api.create(B + "/messages", { to, text });

export const sendChatMessageWith = (to, text, attachments, replyTo) =>
  api.create(B + "/messages", { to, text, attachments, replyTo });

// Хариу үйлдэл (зүрх гэх мэт). Ижилийг дахин дарвал буцаана.
export const reactChatMessage = (id, emoji) =>
  api.create(B + "/messages/" + id + "/react", { emoji });

export const deleteChatMessage = (id) => api.delete(B + "/messages/" + id);

// Мессежийг нэг буюу хэд хэдэн хүн рүү дамжуулах
export const forwardChatMessage = (id, to) =>
  api.create(B + "/messages/" + id + "/forward", { to });

// Файл байршуулах — multipart. `api_helper`-ийн APIClient нь JSON-д зориулагдсан
// тул энд axios-ыг шууд ашиглана.
export const uploadChatFiles = async (files) => {
  const fd = new FormData();
  [...files].forEach((f, i) => fd.append(`f${i}`, f));
  const r = await axios.post(B + "/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r;
};

// Хавсралтыг ТАТАХ. Статик зам биш, эрх шалгадаг маршрут тул `<img src>`-д
// шууд өгөх боломжгүй (толгойд токен явуулах шаардлагатай). Blob болгож аваад
// object URL үүсгэнэ.
export const fetchChatFile = async (url) => {
  const r = await axios.get(url, { responseType: "blob" });
  // interceptor нь `response.data`-г буцаадаг тул энэ нь аль хэдийн Blob
  return r instanceof Blob ? r : (r && r.data) || r;
};

/* ── Групп чат ── */
export const getChatGroups = () => api.get(B + "/groups");
export const getChatGroupMessages = (id, params) => api.get(B + `/groups/${id}/messages`, params);
export const sendChatGroupMessage = (id, text, attachments, replyTo) =>
  api.create(B + `/groups/${id}/messages`, { text, attachments, replyTo });

/* ── Демо бот яриа (зөвхөн SuperAdmin) ── */
export const getChatBotStatus = () => api.get(B + "/bots/status");
export const startChatBots = (min, max, keep, slug) =>
  api.create(B + "/bots/start", { min, max, keep, slug });
export const stopChatBots = (slug) => api.create(B + "/bots/stop", { slug });
export const burstChatBots = (count, slug) => api.create(B + "/bots/burst", { count, slug });

// Группын БҮХ мессежийг устгах (зөвхөн SuperAdmin) — сан дүүрэхээс сэргийлнэ
export const clearChatGroup = (id) => api.delete(B + `/groups/${id}/messages`);

/* ── SuperAdmin: чатын хяналт (зөвхөн унших) ── */
export const getChatAdminConversations = () => api.get(B + "/admin/conversations");
export const getChatAdminThread = (a, b, params) => api.get(B + `/admin/thread/${a}/${b}`, params);
export const getChatAdminStats = () => api.get(B + "/admin/stats");
export const getChatAdminGroup = (id, params) => api.get(B + "/admin/group/" + id, params);
